import React from "react"

import CarouselComponent from "./carousel"

const RegisterContent = () => {

  return (
    <div className='register-content-container'>
      <img
        src={IMAGES_LOGO_BLACK}
        alt='logo'
      />

      <div className="register-content">
        <h5>
          Over <span>50,000+ of the world&apos;s fastest-growing</span> companies use Clearout to:
        </h5>
        <ul>
          <li>Stop spammers from entering your database</li>
          <li>Enrich contact records with precision</li>
          <li>Engage prospects; ensure deliverability</li>
          <li>Integrate smoothly with your tech stack</li>
          <li>Drive sustainable business growth with a 4-fold higher ROI</li>
        </ul>
      </div>

      <CarouselComponent />
    </div>
  )
}

export default RegisterContent
